import moment from 'moment/moment'

/**
 * Allow to transmitted date => 2023-12-27 02:57
 * @param dateToBeTransmitted
 * @returns {string}
 */
export function transformDateTypeEnglishWithSpace (dateToBeTransmitted) {
  const date = new Date(dateToBeTransmitted).toLocaleDateString('pt-BR', { year: 'numeric', month: '2-digit', day: '2-digit' }).split('/').reverse().join('-')
  const time = new Date(dateToBeTransmitted).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
  return `${date} ${time}`
}

/**
 * Allow to adjust month of date
 * @param date
 * @param monthOffset
 * @returns {Date}
 */
export function getAdjustedMonthDate (date, monthOffset) {
  const newDate = new Date(date)
  const day = newDate.getDate()

  newDate.setMonth(newDate.getMonth() + monthOffset)

  // Ajuster le jour si le mois ne compte pas suffisamment de jours
  if (newDate.getDate() < day) {
    newDate.setDate(0) // Cela ramène la date au dernier jour du mois précédent
  }

  return newDate
}

/**
 * Allow to return date to format ISO
 * @param date
 * @returns {string}
 */
export function formatDateToISO (date) {
  const pad = (num) => String(num).padStart(2, '0')
  const newDate = new Date(date)
  const year = newDate.getFullYear()
  const month = pad(newDate.getMonth() + 1) // Les mois sont de 0 à 11
  const day = pad(newDate.getDate())
  const hours = pad(newDate.getHours())
  const minutes = pad(newDate.getMinutes())
  const seconds = pad(newDate.getSeconds())

  // Obtenir le décalage horaire en minutes et le convertir en heures et minutes
  const offset = newDate.getTimezoneOffset()
  const offsetHours = pad(Math.floor(Math.abs(offset) / 60))
  const offsetMinutes = pad(Math.abs(offset) % 60)
  const offsetSign = offset <= 0 ? '+' : '-'

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${offsetSign}${offsetHours}:${offsetMinutes}`
}

/**
 * Allow to return the next month date
 * @param date
 * @returns {string}
 */
export function getNextMonthDate (date) {
  const nextMonthDate = getAdjustedMonthDate(date, 1)
  return formatDateToISO(nextMonthDate)
}

/**
 * Allow to return the previous month date
 * @param date
 * @returns {string}
 */
export function getPreviousMonthDate (date) {
  const previousMonthDate = getAdjustedMonthDate(date, -1)
  return formatDateToISO(previousMonthDate)
}

export function getRangeMonth (dateStr) {
  const date = new Date(dateStr)
  const year = date.getFullYear()
  const month = date.getMonth() // 0 = Jan, 1 = Feb, ..., 11 = Dec

  // Premier jour du mois
  const startOfMonth = new Date(year, month, 1)

  // Dernier jour du mois
  const endOfMonth = new Date(year, month + 1, 0) // Le 0 du mois suivant donne le dernier jour du mois actuel

  return {
    startDate: startOfMonth.toISOString().split('T')[0], // Format YYYY-MM-DDTHH:mm:ss.sssZ
    endDate: endOfMonth.toISOString().split('T')[0]
  }
}

export function getFirstAndLastDayFromDate (date) {
  // Obtenir l'année et le mois à partir de l'objet Date
  const year = date.getFullYear()
  const month = date.getMonth() // Les mois commencent à 0 en JavaScript

  // Date du premier jour du mois
  const firstDay = new Date(year, month, 1)

  // Date du dernier jour du mois
  const lastDay = new Date(year, month + 1, 0) // 0 = dernier jour du mois précédent

  // Formatage des dates en ISO (UTC)
  const firstDayISO = firstDay.toISOString().split('T')[0]
  const lastDayISO = lastDay.toISOString().split('T')[0]

  return { startDate: firstDayISO, endDate: lastDayISO }
}

export function convertDate (date) {
  return 'Le ' + moment(date).format('DD/MM/YYYY à HH:mm')
}

export function convertDateWithOutTime (date) {
  return moment(date).format('DD/MM/YYYY')
}

export function isDaylightSavingTime (date = new Date()) {
  // Obtenir l'offset actuel de la date en minutes
  const currentOffset = date.getTimezoneOffset()

  // Déterminer l'offset d'une date en heure d'hiver (par exemple janvier)
  const winterOffset = new Date(date.getFullYear(), 0, 1).getTimezoneOffset()

  // Si l'offset actuel est inférieur à l'offset d'hiver, c'est l'heure d'été
  return currentOffset < winterOffset
}

export function getNextDate (dateString) {
  const date = new Date(dateString)
  date.setDate(date.getDate() + 1) // Ajoute un jour à la date
  return date.toISOString().split('T')[0] // Retourne la date au format 'YYYY-MM-DD'
}
